// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 1100px) {
    .style__sectionContainer___TxZkO {
        width: 100vw;
        padding-top: 10vw;
        padding-bottom: 10vw;
        display: flex;
        height: 80vh;
    }

    .style__section___HK1Yu {
        width: 90%;
        margin-left: 5vw;
        display: flex;
        position: relative;
        flex-direction: column;
        padding-top: 5vh;
    }

    .style__heading___gx9Pb {
        font-size: 7vw;
        font-weight: bold;
    }

    .style__description___Pt47L {
        font-size: 5vw;
        margin-top: 5vh;
        color: #FFFFFF;
        text-align: left;
        line-height: 1.5;
    }

    .style__description2___l08uq {
        color: var(--black);
        font-size: 4.5vw;
    }

}


@media screen and (min-width: 1100px) {
    .style__sectionContainer___TxZkO {
        width: 100vw;
        padding-top: 10vw;
        padding-bottom: 10vw;
        display: flex;
        height: 40vh;
    }

    .style__section___HK1Yu {
        width: 80%;
        margin-left: 10vw;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .style__heading___gx9Pb {
        font-size: 2.5vw;
        font-weight: bold;
    }

    .style__description___Pt47L {
        font-size: 1.2vw;
        margin-top: 3vh;
        color: #FFFFFF;
        text-align: left;
        line-height: 1.5;
    }

    .style__description2___l08uq {
        color: var(--black);
        font-size: 1vw;
        width: 90%
    }

}
`, "",{"version":3,"sources":["webpack://./src/components/HomeSection/style.css"],"names":[],"mappings":"AAAA;IACI;QACI,YAAY;QACZ,iBAAiB;QACjB,oBAAoB;QACpB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,aAAa;QACb,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;AAEJ;;;AAGA;IACI;QACI,YAAY;QACZ,iBAAiB;QACjB,oBAAoB;QACpB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB,aAAa;QACb,mBAAmB;QACnB,6BAA6B;IACjC;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,cAAc;QACd;IACJ;;AAEJ","sourcesContent":["@media screen and (max-width: 1100px) {\n    .sectionContainer {\n        width: 100vw;\n        padding-top: 10vw;\n        padding-bottom: 10vw;\n        display: flex;\n        height: 80vh;\n    }\n\n    .section {\n        width: 90%;\n        margin-left: 5vw;\n        display: flex;\n        position: relative;\n        flex-direction: column;\n        padding-top: 5vh;\n    }\n\n    .heading {\n        font-size: 7vw;\n        font-weight: bold;\n    }\n\n    .description {\n        font-size: 5vw;\n        margin-top: 5vh;\n        color: #FFFFFF;\n        text-align: left;\n        line-height: 1.5;\n    }\n\n    .description2 {\n        color: var(--black);\n        font-size: 4.5vw;\n    }\n\n}\n\n\n@media screen and (min-width: 1100px) {\n    .sectionContainer {\n        width: 100vw;\n        padding-top: 10vw;\n        padding-bottom: 10vw;\n        display: flex;\n        height: 40vh;\n    }\n\n    .section {\n        width: 80%;\n        margin-left: 10vw;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-evenly;\n    }\n\n    .heading {\n        font-size: 2.5vw;\n        font-weight: bold;\n    }\n\n    .description {\n        font-size: 1.2vw;\n        margin-top: 3vh;\n        color: #FFFFFF;\n        text-align: left;\n        line-height: 1.5;\n    }\n\n    .description2 {\n        color: var(--black);\n        font-size: 1vw;\n        width: 90%\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionContainer": `style__sectionContainer___TxZkO`,
	"section": `style__section___HK1Yu`,
	"heading": `style__heading___gx9Pb`,
	"description": `style__description___Pt47L`,
	"description2": `style__description2___l08uq`
};
export default ___CSS_LOADER_EXPORT___;
